var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRarible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 49 48",
    width: 49,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.623 0c-5.81353 0-10.5263203 4.69794-10.5263203 10.4931v26.8625c0 5.7952 4.7127903 10.4931 10.5263203 10.4931h26.9474c5.8135 0 10.5263-4.6979 10.5263-10.4931v-26.8625c0-5.79516-4.7128-10.4931-10.5263-10.4931zm22.6707 23.8644c1.5072-.3966 2.8482-1.5383 2.8482-3.8336 0-3.8215-3.2042-4.7107-7.3102-4.7107h-16.3531v17.2087h6.883v-5.8404h8.1647c1.2579 0 1.9937.5047 1.9937 1.7545v4.0859h6.883v-4.3022c0-2.3433-1.3054-3.8215-3.1093-4.3622zm-4.624-3.7364h-9.305v2.3463h9.305v-.0007c.0139.0005.0278.0007.0418.0007.6399 0 1.1586-.5252 1.1586-1.1731 0-.648-.5187-1.1732-1.1586-1.1732-.014 0-.0279.0003-.0418.0008z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRarible);
export default __webpack_public_path__ + "static/media/Rarible.8c342f81b93b99fa269743ee2efd434f.svg";
export { ForwardRef as ReactComponent };